import React, { useState } from 'react';
import { connect } from 'react-redux';
import { setFixedCosts, setActiveTab } from '../actions/actions';
import styled from 'styled-components';
import { Typography, Container, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import SendIcon from '@material-ui/icons/Send';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import NumberFormat from 'react-number-format';
import { Fade } from '@material-ui/core';


const useStyles = makeStyles(theme => ({
  root: {
    padding: '2px 4px',
    display: 'flex',
    alignItems: 'center',
    width: 400,
    marginTop: 12
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
  divider: {
    height: 28,
    margin: 4,
  },
}));

const ContentArea = styled.div`
  display: grid;
  grid-template-rows: auto auto auto;
  margin: 16px;
  @media (min-width: 801px) {
    border-right: 1px solid #8080803d;
  };`;


const TabTitle = styled(Typography)`
  place-self: center;
  margin-right: 12px !important;
  margin-top: 16px !important;
`;

const EmailContainer = styled(Container)`
  margin: 12px;
  width: 100%;
}
`

const SendContainer = styled(Container)`
  margin: 12px;
  display: grid;
  grid-template-rows: auto auto auto auto;
}
`

const SaleSuggestion = styled.p`
`;


const BackButton = styled(Button)`
width: auto;
max-width: 800px;
justify-self: start;
align-self: center;
margin-left: 28px !important;
@media (max-width: 768px) {
  span {
    display: none;
  }
  :after {
    content: '<';
    font-size: 16px;
  }
}
`

function TabContent(props) {
  const [checked, setChecked] = React.useState(false);
  const classes = useStyles();
  const [email, setEmail] = useState("")
  const MCPercentage = 100 - props.financialSetup.merchandiseCost - props.variableCosts.percentage
  const MC = props.financialSetup.revenue * (props.financialSetup.merchandiseCost / 100)
  const markup = (1 / (props.financialSetup.merchandiseCost / 100))
  const PE = props.fixedCosts / (1 - (props.variableCosts.percentage / 100) - (props.financialSetup.merchandiseCost / 100))
  
  const profit = props.financialSetup.revenue - props.variableCosts.number - props.fixedCosts - MC

  const operationalProfitPercent = (profit / props.financialSetup.revenue) * 100

  const handleEmailChange = (event) => {
    setEmail(event.target.value)
  }

  const handleChange = () => {
    setChecked(prev => !prev);
  };

  const sendDataToIntercom = () => {
    handleChange()
    window.Intercom("update", {
      app_id: "wifo69cn",
      email: email,
      PE: PE.toFixed(2),
      MC: MCPercentage.toFixed(2),
      markup: markup.toFixed(2),
      CMV: props.financialSetup.merchandiseCost.toFixed(2)
    })
    window.open("https://app.menucontrol.com.br/#/register?email=" + email);
  }
  
  function createData(name, value) {
    return { name, value };
  }

  const rows = [
    createData('Margem de contribuição', MCPercentage.toFixed(2) + "%"),
    createData('Custo de mercadoria', props.financialSetup.merchandiseCost.toFixed(2) + "%"),
    createData('Lucro operacional', operationalProfitPercent.toFixed(2) + "%"),
    createData('Markup', markup.toFixed(2)),
    createData('Ponto de equilíbrio', "R$" + PE.toFixed(2))
  ];
  

  return (
    <ContentArea>
      <TabTitle variant="h4">Indicadores e envio</TabTitle>
      <SendContainer>
        <SaleSuggestion variant="body">Baseado nas informações inseridas, se o seu produto custa 10 reais, recomendamos vendê-lo por <b><NumberFormat value={(10 * markup).toFixed(2)} displayType={'text'} thousandSeparator={'.'} isNumericString={true} decimalSeparator={','}  /> reais (*)</b>. Para obter seus preços de venda, multiplique o custo de suas receitas por <NumberFormat value={(markup).toFixed(2)} displayType={'text'} thousandSeparator={'.'} isNumericString={true} decimalSeparator={','}  /> (markup multiplicador).</SaleSuggestion>
        <small><b>(*)</b> Valores estimados, seus preços devem se adequar ao contexto de mercado, entretanto não devem ficar muito abaixo do recomendado.</small>
      </SendContainer>
      <Container>
        <TableContainer component={Paper}>
            <Table className={classes.table} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Indicador</TableCell>
                  <TableCell align="right">Valor</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map(row => (
                  <TableRow key={row.name}>
                    <TableCell component="th" scope="row">
                      {row.name}
                    </TableCell>
                    <TableCell align="right"><NumberFormat value={row.value.toString()} displayType={'text'} thousandSeparator={'.'} isNumericString={true} decimalSeparator={','} /></TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
      </Container>
      <EmailContainer>
        <Typography variant="subtitle1">Aproveite para <b>criar sua conta gratuitamente</b> e receber seus indicadores por email.</Typography>
        <Paper component="form" className={classes.root}>
          <InputBase
            className={classes.input}
            placeholder="Email"
            value={email}
            onChange={handleEmailChange}
          />
          <Divider className={classes.divider} orientation="vertical" />
          <IconButton color="primary" onClick={() => sendDataToIntercom()} className={classes.iconButton} aria-label="directions">
            <SendIcon />
          </IconButton>
        </Paper>
        <Fade in={checked} timeout={2000}>
          <small>Email enviado com sucesso!</small> 
        </Fade>
      </EmailContainer>
      <BackButton
        variant="contained"
        onClick={() => props.setActiveTab(props.activeTab - 1)}
        color="secondary"
        disabled={props.financialSetup.revenue <= 0}
      >
        Redefinir
      </BackButton>
    </ContentArea>
  );
}

const mapStateToProps = (state) => {
  return {
    financialSetup: state.reducers.financialSetup,
    activeTab: state.reducers.activeTab
  }
}

const mapDispatchToProps = { setFixedCosts, setActiveTab }
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TabContent)
